import {useBoardConfig} from './provider/contexts'
import type {BoardLabels} from './types'

/**
 * The label set the caller passed to `BoardProvider`. Neither package ships a string of
 * its own, so anything that needs one reads it from here.
 */
export function useBoardLabels(): BoardLabels {
  return useBoardConfig().labels
}

/**
 * The caller's `getItemLabel`, for something that names a card in words.
 *
 * It reads the same config `useBoardLabels` does, so a component calling it re-renders
 * whenever the caller hands over a new accessor or label set. Call it where labels are
 * already read, such as in a cell, and hand each card the string rather than calling this
 * once per card.
 */
export function useBoardItemLabel<TItem>(): (item: TItem) => string {
  return useBoardConfig().getItemLabel
}
